import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaNotas = (): TabelaColuna => ({
  Chave: 'notas',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 110 }}>Notas</div>
})
